import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { EnvironmentConfig, BaseApiService, AuthenticationService } from "../../core/core";
import { InventoryGroup } from "../inventory";

declare var environment: EnvironmentConfig;

@Injectable({
  providedIn: "root",
})
export class InventoryGroupService extends BaseApiService<InventoryGroup> {
  constructor(httpClient: HttpClient, authenticationService: AuthenticationService) {
    super(httpClient, environment.assetsApiDomain, "/api/assets/v2/group", true, authenticationService);
  }

  getImages(catalogId: string) {
    const headers = this.getAuth();
    return this.httpClient.get(`${this.baseUrl}${this.endpoint}/${catalogId}/image`, { headers });
  }

  uploadImage(entityId: string, partitionKey: string, selectedFile): Observable<any> {
    const uploadData = new FormData();
    uploadData.append("file", selectedFile);

    let params = new HttpParams();
    params = params.append("partitionKey", partitionKey);

    const headers = this.getAuth();
    return this.httpClient.post(`${this.baseUrl}${this.endpoint}/${entityId}/image`, uploadData, { headers, params });
  }

  deleteImage(catalogId: string, imageId: string): Observable<any> {
    const headers = this.getAuth();
    return this.httpClient.delete(`${this.baseUrl}${this.endpoint}/${catalogId}/image/${imageId}`, { headers });
  }

  // 🆕 Generate Description (POST /api/assets/v2/group/description)
  generateDescription(payload: { make: string; model: string; notes?: string; attachments?: string[] }): Observable<any> {
    const headers = this.getAuth();
    return this.httpClient.post(`${this.baseUrl}${this.endpoint}/description`, payload, { headers });
  }

  // 🆕 Generate Specs (POST /api/assets/v2/group/specs)
  generateSpecs(question: string): Observable<any> {
    const headers = this.getAuth();
    const payload = { question };
    return this.httpClient.post(`${this.baseUrl}${this.endpoint}/specs`, payload, { headers });
  }

  clonePhotos(fromGroupId: string, toGroupId: string, fromPartitionKey: string, toPartitionKey: string): Observable<any> {
    const headers = this.getAuth();
    let params = new HttpParams().set("fromGroupId", fromGroupId).set("toGroupId", toGroupId);

    if (fromPartitionKey) {
      params = params.set("fromPartitionKey", fromPartitionKey);
    }
    if (toPartitionKey) {
      params = params.set("toPartitionKey", toPartitionKey);
    }

    return this.httpClient.post(`${this.baseUrl}${this.endpoint}/copy-images`, {}, { headers, params });
  }
}
